import { render, staticRenderFns } from "./modal-welcome.vue?vue&type=template&id=afd62a3a&scoped=true"
import script from "./modal-welcome.vue?vue&type=script&lang=js"
export * from "./modal-welcome.vue?vue&type=script&lang=js"
import style0 from "./modal-welcome.vue?vue&type=style&index=0&id=afd62a3a&prod&lang=scss"
import style1 from "./modal-welcome.vue?vue&type=style&index=1&id=afd62a3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd62a3a",
  null
  
)

export default component.exports